import './page/xps-product-finder-list';
import './page/xps-product-finder-detail';
import './page/xps-product-finder-create';

const { Module } = Shopware;

Module.register('xps-product-finder', {
    type: 'plugin',
    name: 'xps-product-finder',
    title: 'xps-product-finder.general.mainMenuItemGeneral',
    description: 'xps-product-finder.general.description',
    color: '#4f46e5',
    icon: 'regular-search',

    routes: {
        list: {
            component: 'xps-product-finder-list',
            path: 'list',
            meta: {
                parentPath: 'sw.settings.index'
            }
        },
        detail: {
            component: 'xps-product-finder-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'xps.product.finder.list'
            }
        },
        create: {
            component: 'xps-product-finder-create',
            path: 'create',
            meta: {
                parentPath: 'xps.product.finder.list'
            }
        }
    },

    settingsItem: {
        group: 'plugins',
        to: 'xps.product.finder.list',
        icon: 'regular-search',
        privilege: 'xps_product_finder.viewer'
    }
});